// 登陆模式
export const LOGIN_MODE = {
    EMAIL_PASSWORD: 'EMAILPASSWORD', // 邮箱密码登录
    MOBILE: 'MOBILE', // 手机号密码登录
    TELEGRAM: 'TELEGRAM', // tg登录
    AFTER_REGISTER: 'AFTER_REGISTER', // 注册后登录
    AFTER_SMS_RESCUE_PWD: 'AFTER_SMS_RESCUE_PWD', // 找回密码后登录
}